const getters = {
    sidebar: state => state.app.sidebar,
    visitedViews: state => state.app.visitedViews,

    token: state => state.user.token,
    email: state => state.user.email,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    userOptions: state => state.user.userOptions,

    permission_routers: state => state.permission.routers,
    addRouters: state => state.permission.addRouters
};
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js